const ACCOUNT_ACTIVITY_KEY = 'accountActivity';
const ACCOUNT_MONITORING_CONFIGS_KEY = 'accountMonitoringConfigs';
const ACCOUNT_OWNER_METADATA_KEY = 'accountOwnerMetadata';
const AUTO_GEN_REVIEWS_KEY = 'autoGenReviews';
const BANK_DOCUMENTS_KEY = 'bankDocuments';
const BANK_DISPENSARY_KEY = 'bankDispensary';
const BANK_DISPENSARY_AUDIT_TRAIL_EVENTS_KEY = 'bankDispensaryAuditTrailEvents';
const BANK_KEY = 'bank';
const BANK_TASKS_KEY = 'bankTasks';
const BANK_MARKETPLACE_LEADS_KEY = 'bankMarketplaceLeads';
const BANK_NICKNAME_KEY = 'bankNickname';
const BANK_QUESTIONNAIRES_KEY = 'bankQuestionnaires';
const BANK_TEMPLATES_KEY = 'templates';
const BUSINESS_VERIFICATION_KEY = 'businessVerification';
const DATA_POINTS_KEY = 'dataPoints';
const DISPENSARY_ASSOCIATE_PARENT_KEY = 'dispensaryAssociateParent';
const DISPENSARY_BANNER_STATUS_KEY = 'dispensaryBannerStatus';
const DISPENSARY_LAST_INGESTION_KEY = 'dispensaryLastIngestion';
const DISPENSARY_MARKETPLACE_LEADS_KEY = 'dispensaryMarketplaceLeads';
const DISPENSARY_METADATA_KEY = 'dispensaryMetadata';
const DISPENSARY_PARENT_FOR_LOCATION_KEY = 'dispensaryParentForLocation';
const DISPENSARY_S2S_CONFIG_KEY = 'dispensaryS2sConfig';
const DISPENSARY_STAFF_KEY = 'dispensaryStaff';
const DISPENSARY_UPCOMING_REPORTS_KEY = 'dispensaryUpcomingReports';
const DISPENSARY_USERS_KEY = 'dispensaryUsers';
const DOCUMENTS_KEY = 'documents';
const FI_MARKETPLACE_OFFERS_KEY = 'fiMarketplaceOffers';
const FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY = 'fincenExportRecordSubmissionMetadata';
const GCD_USER_KEY = 'gcdUser';
const INGESTION_DATA_KEY = 'ingestionData';
const INSIGHTS_METADATA_KEY = 'insightsMetadata';
const INTERNAL_DOCUMENTS_KEY = 'internalDocuments';
const INVITED_DISPENSARIES_KEY = 'invitedDispensaries';
const LICENSES_KEY = 'licenses';
const LOCATION_DISPENSARY_KEY = 'locationDispensary';
const MAX_DEPOSIT_KEY = 'maxDeposit';
const MESSAGE_TEMPLATES_KEY = 'messageTemplates';
const METADATA_KEY = 'metadata';
const MINIFIED_DISPENSARIES_KEY = 'minifiedDispensaries';
const MSB_REGISTRATIONS_SEARCH_KEY = 'msbRegistrationsSearch';
const MUOS_KEY = 'muos';
const NEGATIVE_NEWS_KEY = 'negativeNews';
const PAYQWICK_USER_KEY = 'payqwickUser';
const QUESTIONNAIRE_BULK_ASSIGN_KEY = 'questionnaireBulkAssign';
const QUESTIONNAIRE_BULK_UNASSIGN_KEY = 'questionnaireBulkUnassign';
const QUESTIONNAIRE_OVERVIEW_KEY = 'questionnaireOverview';
const QUESTIONNAIRE_TEMPLATES_KEY = 'questionnaireTemplates';
const QUESTIONNAIRE_TO_CRB_KEY = 'questionnaireToCrb';
const REQUEST_REVISION_KEY = 'requestRevision';
const RISK_NARRATIVE_JOURNEYS_KEY = 'riskNarrativeJourneys';
const RISK_NARRATIVE_STRATEGY_KEY = 'riskNarrativeStrategy';
const ROOT_DOCUMENTS_KEY = 'rootDocuments';
const BANK_STAFF_KEY = 'bankStaff';
const STAFF_KEY = 'staff';
const TEMPLATE_KEY = 'template';
const TEMPLATE_RESULT_KEY = 'templateResult';
const TEMPLATES_KEY = 'templates';
const TRANSACTION_CODES_KEY = 'transactionCodes';
const USER_DETAILS_KEY = 'userDetails';
const USER_KEY = 'user';
const INVITE_USER_KEY = 'inviteUser';
const ONBOARDING_DOC_REQ_DOCUMENT_STATUS_KEY = 'onboardingDocReqDocumentStatus';
const GC_MANAGED_TEMPLATE_METADATAS_KEY = 'gcManagedTemplateMetadatas';
const CRB_MARKETPLACE_OFFERS_KEY = 'crbMarketplaceOffers';
const DISPENSARY_BANKS_KEY = 'dispensaryBanks';
const DISPENSARY_BUSINESS_STAGE = 'dispensaryBusinessStage';
const BANK_OMIT_TRANSACTIONS_KEY = 'bankOmitTransactions';
const MONITORING_DATA_SUMMARY_KEY = 'monitoringDataSummary';
const BANK_COUNTERPARTIES_KEY = 'bankCounterparties';
const CORE_TRANSACTIONS_BY_ID_KEY = 'coreTransactionsById';
const CORE_TRANSACTIONS_KEY = 'coreTransactions';
const COUNTERPARTY_ACTIVITY_KEY = 'counterpartyActivity';
const CRB_COUNTERPARTIES_KEY = 'crbCounterparties';

export {
  ACCOUNT_ACTIVITY_KEY,
  ACCOUNT_MONITORING_CONFIGS_KEY,
  ACCOUNT_OWNER_METADATA_KEY,
  AUTO_GEN_REVIEWS_KEY,
  BANK_COUNTERPARTIES_KEY,
  BANK_DISPENSARY_AUDIT_TRAIL_EVENTS_KEY,
  BANK_DISPENSARY_KEY,
  BANK_DOCUMENTS_KEY,
  BANK_KEY,
  BANK_MARKETPLACE_LEADS_KEY,
  BANK_NICKNAME_KEY,
  BANK_OMIT_TRANSACTIONS_KEY,
  BANK_QUESTIONNAIRES_KEY,
  BANK_STAFF_KEY,
  BANK_TASKS_KEY,
  BANK_TEMPLATES_KEY,
  BUSINESS_VERIFICATION_KEY,
  CORE_TRANSACTIONS_BY_ID_KEY,
  CORE_TRANSACTIONS_KEY,
  COUNTERPARTY_ACTIVITY_KEY,
  CRB_COUNTERPARTIES_KEY,
  CRB_MARKETPLACE_OFFERS_KEY,
  DATA_POINTS_KEY,
  DISPENSARY_ASSOCIATE_PARENT_KEY,
  DISPENSARY_BANKS_KEY,
  DISPENSARY_BANNER_STATUS_KEY,
  DISPENSARY_BUSINESS_STAGE,
  DISPENSARY_LAST_INGESTION_KEY,
  DISPENSARY_MARKETPLACE_LEADS_KEY,
  DISPENSARY_METADATA_KEY,
  DISPENSARY_PARENT_FOR_LOCATION_KEY,
  DISPENSARY_S2S_CONFIG_KEY,
  DISPENSARY_STAFF_KEY,
  DISPENSARY_UPCOMING_REPORTS_KEY,
  DISPENSARY_USERS_KEY,
  DOCUMENTS_KEY,
  FI_MARKETPLACE_OFFERS_KEY,
  FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY,
  GC_MANAGED_TEMPLATE_METADATAS_KEY,
  GCD_USER_KEY,
  INGESTION_DATA_KEY,
  INSIGHTS_METADATA_KEY,
  INTERNAL_DOCUMENTS_KEY,
  INVITE_USER_KEY,
  INVITED_DISPENSARIES_KEY,
  LICENSES_KEY,
  LOCATION_DISPENSARY_KEY,
  MAX_DEPOSIT_KEY,
  MESSAGE_TEMPLATES_KEY,
  METADATA_KEY,
  MINIFIED_DISPENSARIES_KEY,
  MONITORING_DATA_SUMMARY_KEY,
  MSB_REGISTRATIONS_SEARCH_KEY,
  MUOS_KEY,
  NEGATIVE_NEWS_KEY,
  ONBOARDING_DOC_REQ_DOCUMENT_STATUS_KEY,
  PAYQWICK_USER_KEY,
  QUESTIONNAIRE_BULK_ASSIGN_KEY,
  QUESTIONNAIRE_BULK_UNASSIGN_KEY,
  QUESTIONNAIRE_OVERVIEW_KEY,
  QUESTIONNAIRE_TEMPLATES_KEY,
  QUESTIONNAIRE_TO_CRB_KEY,
  REQUEST_REVISION_KEY,
  RISK_NARRATIVE_JOURNEYS_KEY,
  RISK_NARRATIVE_STRATEGY_KEY,
  ROOT_DOCUMENTS_KEY,
  STAFF_KEY,
  TEMPLATE_KEY,
  TEMPLATE_RESULT_KEY,
  TEMPLATES_KEY,
  TRANSACTION_CODES_KEY,
  USER_DETAILS_KEY,
  USER_KEY
};
